<template>
  <div class="about">
    <div class="overlay">
      <router-view></router-view>
    </div>
    <LMap id="mapid" :center="getCenter" :zoom="zoom">
      <LTileLayer :url="url"></LTileLayer>
      <LMarker
        :key="index"
        v-for="(marker, index) in getMarkers"
        :lat-lng="marker.marker"
        @click="onMarkerClick(marker.article)"
      ></LMarker>
    </LMap>
  </div>
</template>
<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import countries from "../assets/countries.js";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      center: [47.41322, -1.219482],
      zoom: 4,
      src: null,
      options: {
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: false
      },
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    };
  },
  methods: {
    ...mapActions(["setCurrentArticle"]),
    pan() {
      const index = Math.floor(Math.random() * countries.length);
      const { latitude, longitude, country } = countries[index];
      this.center = [latitude, longitude];
      this.src =
        "https://www.countryflags.io/" + country.toLowerCase() + "/flat/64.png";
      setTimeout(() => (this.zoom = 6), 200);
    },
    async onMarkerClick(art) {
      console.log("salam");
      await this.setCurrentArticle(art);
      this.$router.push("/article");
    }
  },
  computed: {
    ...mapGetters(["getContinents", "getCenter", "getMarkers"])
  }
};
</script>
<style>
#mapid {
  z-index: 0;
}

.md-app-content {
  padding: 0 !important;
}

.title {
  font-size: 28px;
  text-align: left;
}

.card {
  background-color: white;
  margin: 10px;
  width: 200px;
  color: black;
  border: 1px solid black;
  padding: 20px;
  border-radius: 7px;
}

.contentName {
  font-size: 20px;
}

@media only screen and (max-width: 959px) {
  #mapid {
    z-index: 0;
    height: 40vh !important;
  }
}
</style>